import React from "react";
import { BaseComponent } from "../baseComponent/BaseComponent";

export class OpenAuctionWithDeposit extends BaseComponent {
    constructor(props) {
        super(props);
    }

    Details() {
        return (
            <>
                <div className="aboutTrade detailsWrapper">
                    <div className="tradeInfo">
                        <div className="infoItem">
                            <span className="defaultDataName">Вид торгов:</span>
                            <p className="defaultDataValue">{this.state.Lot.TradeTypeDescription}</p>
                        </div>

                        <div className="infoItem">
                            <span className="defaultDataName">Статус:</span>
                            <p className="defaultDataValue">{this.state.Lot.LotTradeStatusDescription}</p>
                        </div>

                        <div className="infoItem">
                            <span className="defaultDataName">Начало аукциона:</span>
                            <p className="defaultDataValue">
                                {this.GetDate(this.state.Lot.LotTradePeriodStart)}
                            </p>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    renderTradeHint() {
        return (
            <div style={{display: "flex", gap: "5px"}}>
                <p style={{ color: "#170021"}} className="defaultDescription">Нужна ЭЦП</p>
            </div>
        );
    }

    renderIsDeposit() {
        return <span><br/><b>c задатком</b></span>
    }

    render() {
        return (
            <React.Fragment>
                {this.ShortInfoLot()}
            </React.Fragment>
        )
    }
}